import { isEmpty } from '../../common/misc';
import { useAuthedUser } from '../../common/providers/AuthedUserProvider';
import {
    centsToFormattedDollars,
    transformBankAccountDetails,
} from '../../common/utils/bankingUtils';
import { requestBuilder } from '../../http/RequestBuilder';
import type { SavingsDetails } from '../types/BankAccount';

const useGetAllAccountDetails = requestBuilder.query<
    SavingsDetails,
    { userId: string }
>({
    endpoint: ({ userId }) => `/api/bank-accounts/user/${userId}/all-details`,
    queryKey: ({ userId }) => `getAllAccountDetails/${userId}`,
});

const useGetAllBankAccountDetailsLegacy = (enabled = true) => {
    const user = useAuthedUser();

    const {
        status,
        data: savingsDetails,
        isLoading,
        refetch: refetchAccountDetails,
        isRefetching,
    } = useGetAllAccountDetails({ userId: user.id }, { enabled });

    const errorFetching = status === 'error';

    const {
        totalAvailableBalanceCents,
        totalInterestEarnedCents,
        bankAccountDetails: rawDetails,
    } = savingsDetails ?? {};

    const bankAccountDetails = (rawDetails ?? []).map((b) =>
        transformBankAccountDetails(b),
    );

    return {
        isLoading: isLoading || isRefetching,
        errorFetching,
        bankAccountDetails,
        hasAccount: isLoading ? undefined : !isEmpty(bankAccountDetails),
        refetchAccountDetails,
        totalAvailableBalance: centsToFormattedDollars(
            totalAvailableBalanceCents ?? 0,
        ),
        totalInterestEarned: centsToFormattedDollars(
            totalInterestEarnedCents ?? 0,
        ),
    };
};

export default useGetAllBankAccountDetailsLegacy;
